import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Users } from '../Users';
import { Companies } from '../../companies/Companies';
import { useI18n } from '../../i18n/useI18n';
import styles from '../styles/adminTabs.module.scss';

export const AdminTabs = () => {
  const { t } = useI18n();

  return (
    <div className={styles.adminTabs}>
      <Tabs>
        <TabList>
          <Tab>{t('module_users.module_title')}</Tab>
          <Tab>{t('list_menu.list_menu_companies')}</Tab>
        </TabList>

        <TabPanel>
          <Users />
        </TabPanel>
        <TabPanel>
          <Companies />
        </TabPanel>
      </Tabs>
    </div>
  );
}; 